import en from './en.mjs'

export default Object.freeze({
  ...en,
  'common.language.label': '언어',
  'common.download.action': '다운로드',
  'common.store.appleprefix': 'App Store에서',
  'common.store.googleprefix': 'Google Play에서',
  'seo.home.title': 'Happy Pets | AI 동반자, 자기 탐색 테스트와 펫 위젯',
  'seo.home.description': '일상 성찰, 성격 테스트, 타로, 꿈 이야기, 위젯, 친구와 공동 양육을 즐길 수 있는 AI 가상 반려동물입니다.',
  'seo.home.keywords': 'Happy Pets, AI 동반자, 가상 반려동물, 위젯, 성격 테스트, MBTI, AI 타로',
  'seo.invite.title': 'Happy Pets 초대 | 친구와 가상 반려동물 키우기',
  'seo.invite.description': 'Happy Pets 초대를 열고 iPhone 또는 Android에서 친구와 가상 반려동물을 입양하고 함께 키워 보세요.',
  'nav.skills.label': '스킬',
  'nav.tests.label': '테스트',
  'nav.guidance.label': 'AI 가이드',
  'nav.features.label': '기능',
  'nav.experience.label': '경험',
  'nav.community.label': '커뮤니티',
  'nav.news.label': '뉴스',
  'home.hero.titlelead': '작은 반려동물이,',
  'home.hero.titleaccent': '매일 조금씩 도와줘요',
  'home.hero.subtitle': '화면 속에서 사는 포근한 가상 반려동물을 입양하세요. 함께 성장하며 일상에 도움과 재미, 편안한 동행을 주는 유용한 스킬을 배웁니다.',
  'home.tools.eyebrow': '펫 스킬',
  'home.tools.title': '반려동물이 도와주는 일상의 작은 일',
  'home.tools.description': '성찰, 식사 아이디어, 성격 이해, 일상의 작은 결정까지 돕는 유용한 동반자가 되어 줍니다.',
  'home.tools.action': '지금 체험',
  'tool.tarot.tag': '성찰',
  'tool.tarot.title': '타로',
  'tool.tarot.description': '반려동물이 카드를 뽑아 현재 질문을 다른 시선으로 바라보도록 도와줍니다.',
  'tool.mbti.tag': '성격',
  'tool.mbti.title': 'MBTI',
  'tool.mbti.description': '유형과 패턴을 비교하며 내가 생각하고 관계 맺는 방식을 알아봅니다.',
  'tool.chef.tag': '주방',
  'tool.chef.title': '냉장고 셰프',
  'tool.chef.description': '냉장고 속 재료를 영리한 작은 셰프와 함께 간단한 요리로 바꿔 보세요.',
  'tool.fortune.tag': '매일',
  'tool.fortune.title': '오늘의 운세',
  'tool.fortune.description': '기분과 행운, 다가올 작은 순간을 가볍게 살펴보며 하루를 시작합니다.',
  'tool.calorie.tag': '건강',
  'tool.calorie.title': '칼로리 계산기',
  'tool.calorie.description': '칼로리를 추정하고 영양 패턴을 살펴 더 편하게 식사를 선택하세요.',
  'tool.dream.tag': '꿈',
  'tool.dream.title': '꿈 해석',
  'tool.dream.description': '어젯밤 꿈의 상징을 정리하고 흐릿한 장면을 성찰할 주제로 바꿉니다.',
  'home.assessments.eyebrow': '나를 더 잘 알기',
  'home.assessments.title': '결과를 더 탐색할 수 있는 자기 발견 테스트',
  'home.assessments.description': '성격, 추론, 진로 또는 관계 테스트를 하고 결과를 AI 동반자와의 대화에서 더 깊이 탐색하세요.',
  'home.assessments.action': '테스트 시작',
  'home.assessments.disclaimer': '이 테스트는 자기 탐색과 오락을 위한 것으로 의료 진단이나 전문가의 조언을 대신하지 않습니다.',
  'assessment.mbti.eyebrow': '성격',
  'assessment.mbti.title': 'MBTI 성격 테스트',
  'assessment.mbti.description': '선호, 소통 방식, 강점과 성장 패턴을 자세히 살펴봅니다.',
  'assessment.mbti.meta': '108문항',
  'assessment.sbti.eyebrow': '사회적 스타일',
  'assessment.sbti.title': 'SBTI 성격 테스트',
  'assessment.sbti.description': '감정, 행동, 사회적 에너지 등 다섯 가지 재미있는 차원으로 사람들과 어울리는 모습을 알아봅니다.',
  'assessment.sbti.meta': '62문항',
  'assessment.iq.eyebrow': '추론',
  'assessment.iq.title': 'IQ 추론 평가',
  'assessment.iq.description': '비언어적 패턴을 풀고 다양한 추론 영역을 비교해 봅니다.',
  'assessment.iq.meta': '시각 추론',
  'assessment.holland.eyebrow': '진로',
  'assessment.holland.title': '홀랜드 직업 흥미',
  'assessment.holland.description': '여섯 가지 흥미 영역에서 나에게 자연스러운 활동과 업무 환경을 찾아봅니다.',
  'assessment.holland.meta': '직업 흥미',
  'assessment.attachment.eyebrow': '관계',
  'assessment.attachment.title': '애착 유형 테스트',
  'assessment.attachment.description': '친밀감, 신뢰, 안정감, 독립성을 돌아보며 관계 패턴을 이해합니다.',
  'assessment.attachment.meta': '관계 인사이트',
  'home.guidance.eyebrow': '부드러운 매일의 의식',
  'home.guidance.title': '성찰에 기반한 AI 신비 가이드',
  'home.guidance.description': '타로, 오늘의 운세, 꿈의 상징을 통해 잠시 멈추고 감정을 표현하며 실행 가능한 다음 한 걸음을 찾습니다. 미래의 확신보다 오늘의 명료함과 편안함을 위한 경험입니다.',
  'guidance.tarot.title': 'AI 타로',
  'guidance.tarot.description': '질문에 맞춰 카드를 고르고 해석을 성찰과 새로운 관점, 다음 한 걸음을 위한 부드러운 힌트로 활용하세요.',
  'guidance.tarot.note': '성찰과 오락을 위해',
  'guidance.fortune.title': '오늘의 운세',
  'guidance.fortune.description': '기분, 에너지, 행운의 포인트와 실용적인 응원을 가볍게 살피며 하루를 시작하세요.',
  'guidance.fortune.note': '매일 새로운 가이드',
  'guidance.dream.title': '꿈 해석',
  'guidance.dream.description': '꿈의 장면과 감정을 고정된 예언이 아닌 탐색할 수 있는 주제로 바꿉니다.',
  'guidance.dream.note': '상징, 감정과 성찰',
  'home.features.eyebrow': '유용한 스킬, 매일의 즐거움',
  'home.features.title': '반려동물이 점점 더 든든해지는 이유',
  'feature.raise.title': '사랑스러운 반려동물 키우기',
  'feature.raise.description': '먹이를 주고 놀아 주며 귀엽고 편안하면서도 유용한 동반자로 성장하는 모습을 지켜보세요.',
  'feature.hatch.title': '새로운 스킬 부화',
  'feature.hatch.description': '알을 모으고 서로 다른 성격과 유용한 스킬을 가진 특별한 반려동물을 만나세요.',
  'feature.coraising.title': '친구와 함께 키우기',
  'feature.coraising.description': '친구를 초대해 함께 돌보세요. 사랑도 재미도 두 배가 됩니다.',
  'feature.status.title': '매일 상태',
  'feature.status.description': '하루의 상태를 기록하고 반려동물에게 감정을 나눠 보세요.',
  'feature.frequency.title': '매일 빈도',
  'feature.frequency.description': '물 마시기, 달리기 등 나만의 활동을 만들고 빈도를 기록하세요.',
  'feature.cleaner.title': '사진 정리',
  'feature.cleaner.description': '놀면서 갤러리를 깔끔하게 정리하세요. 재미있고 생산적입니다.',
  'feature.skills.title': 'AI 스킬룸',
  'feature.skills.description': '새로운 모습을 잠금 해제하고 성찰, 계획, 일상에 도움을 주는 더 많은 방법을 찾아보세요.',
  'feature.widget.title': '인터랙티브 위젯',
  'feature.widget.description': '홈 화면의 인터랙티브 위젯으로 반려동물을 늘 가까이 두세요.',
  'home.steps.eyebrow': '시작하기',
  'home.steps.title': '유용한 스킬을 가진 반려동물을 부화하세요',
  'step.adopt.title': '입양',
  'step.adopt.description': '나만의 특별한 알을 고르고 반려동물과 함께하는 여정을 시작하세요.',
  'step.grow.title': '성장',
  'step.grow.description': '매일 먹이를 주고 놀며 교감해 새로운 스킬을 배우도록 키워 주세요.',
  'step.together.title': '함께',
  'step.together.description': '친구를 초대하고 개성과 응원으로 가득한 세상을 함께 나누세요.',
  'home.reviews.eyebrow': '커뮤니티',
  'home.reviews.title': '귀여움 그 이상으로 사랑받아요',
  'home.reviews.role': '반려동물 가족',
  'home.news.eyebrow': '뉴스와 이야기',
  'home.news.title': '최신 소식',
  'home.news.description': '펫과 함께하는 삶, 자기 발견, 일상의 웰빙을 위한 다정한 아이디어를 만나보세요.',
  'home.news.readarticle': '기사 읽기',
  'home.news.exploreall': '모든 소식 보기',
  'review.one.text': '반려동물도 귀엽지만 작은 일상 스킬을 이렇게 자주 쓰게 될 줄은 몰랐어요.',
  'review.two.text': '남자친구와 함께 키우는 게 즐겁고 추가 스킬도 매일 유용해요.',
  'review.three.text': '위젯이 정말 인터랙티브해요. 홈 화면의 귀여운 동반자가 일상도 도와줘서 좋아요.',
  'home.footer.tagline': '홈 화면에 즐거움과 동행을 더하세요.',
  'home.footer.product': '제품',
  'home.footer.support': '지원',
  'home.footer.social': '소셜',
  'home.footer.skills': '펫 스킬',
  'home.footer.features': '기능',
  'home.footer.widgets': '위젯',
  'home.footer.help': '도움말 센터',
  'home.footer.privacy': '개인정보 처리방침',
  'home.footer.terms': '이용약관',
  'home.footer.copyright': '© 2024 Happy Pet. 모든 권리 보유.',
  'home.image.logoalt': 'Happy Pets 로고',
  'home.image.screenalt': 'Happy Pets 앱 화면',
  'home.image.enlargedalt': '확대한 Happy Pets 화면',
  'home.image.close': '이미지 닫기',
  'invite.headline': '친구가 함께 반려동물을 키우자고 초대했어요!',
  'invite.description': '초대를 수락하면 알이 즉시 부화합니다. 반려동물을 홈 화면에도 추가해 보세요.',
  'invite.download': '다운로드',
  'invite.loadingalt': 'Happy Pets 불러오는 중',
  'invite.screensalt': 'Happy Pets 앱 스크린샷'
})
